import { render, staticRenderFns } from "./PlantLibraryComponent.vue?vue&type=template&id=5531c082&scoped=true"
import script from "./PlantLibraryComponent.vue?vue&type=script&lang=js"
export * from "./PlantLibraryComponent.vue?vue&type=script&lang=js"
import style0 from "./PlantLibraryComponent.vue?vue&type=style&index=0&id=5531c082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5531c082",
  null
  
)

export default component.exports